import { render, staticRenderFns } from "./goodsSet.vue?vue&type=template&id=987511d8&scoped=true&"
import script from "./goodsSet.vue?vue&type=script&lang=js&"
export * from "./goodsSet.vue?vue&type=script&lang=js&"
import style0 from "./goodsSet.vue?vue&type=style&index=0&id=987511d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987511d8",
  null
  
)

export default component.exports